import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell, PlaceholderCard } from "@/components/DashboardShell";
import { ADMIN_NAV } from "@/lib/nav";

export const Route = createFileRoute("/_authenticated/admin/dashboard")({
  head: () => ({
    meta: [
      { title: "Overview · Landoo Admin" },
      { name: "description", content: "Overview — Landoo admin console." },
    ],
  }),
  component: () => (
    <DashboardShell title="Overview" role="Admin" items={ADMIN_NAV}>
      <PlaceholderCard
        title="Overview"
        description="Admin queue for Overview. Actions and filters will be added here."
      />
    </DashboardShell>
  ),
});
